
<template>
  <div class="background">
    <div v-anime="{opacity: 1, loop: false, duration: 3000 }" class="content container">
      <div class="row mt-4">
        <div class="about-bio col-md align-self-center">
          <img
            class="about-bio-image w-50 rounded-circle"
            alt="Vue logo"
            src="../assets/avatar-daniel.png"
          />
          <p
            class="mt-4"
          >My name is Daniel Hogrebe I am a software developer currently based in North Rhine-Westphalia playing around with technology. Every now and then I feel the urge to deep dive into new stuff and sometimes this leads to something I wanna share. I am always curious, sometimes obsessive, but never bored. Take a look at my services. Feel free to contact me!</p>
          <div class="contact mt-4">
            <a
              href="https://github.com/SundayLab"
              class="btn btn-round btn-clear btn-instagram github mr-1"
            >
              <i class="fa fa-github fa-1x"></i>
            </a>
            <a
              href="https://www.xing.com/profile/Daniel_Hogrebe"
              class="btn btn-round btn-clear btn-instagram xing mr-1"
            >
              <i class="fa fa-xing fa-1x"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/daniel-hogrebe-ab405a167/"
              class="btn btn-round btn-clear btn-instagram linked mr-1"
            >
              <i class="fa fa-linkedin fa-1x"></i>
            </a>
            <a
              href="mailto:daniel.hogrebe@googlemail.com?Subject=SundayLab"
              class="btn btn-round btn-clear btn-instagram mail mr-1"
              target="_top"
            >
              <i class="fa fa-envelope-o fa-1x"></i>
            </a>
          </div>
        </div>
        <div class="col align-self-center ml-4">
          <canvas width="100" height="100" ref="chart"></canvas>

          <!-- <div class="radarChart tile mt-4"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  mounted: function() {
    var chart = this.$refs.chart;
    var ctx = chart.getContext("2d");
    new Chart(ctx, {
      type: "radar",
      data: {
        labels: [
          "Java",
          "TypeScript",
          "Python",
          "Javascript",
          "C#",
          "Deep RL",
          "Keras",
          "Three.js",
          "D3",
          "Android",
          "Angular",
          "Vue",
          "React",
          "Ionic"
        ],
        datasets: [
          {
            label: "Skill in %",
            pointRadius: 5,
            data: [90, 100, 70, 90, 60, 30, 40, 80, 80, 70, 100, 50, 60, 80],
            backgroundColor: "rgba(50, 247, 251, 0.4)",
            pointBackgroundColor: [
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)",
              "rgba(61, 58, 180, 1.0)"
            ]
          }
        ]
      },
      options: {
        animation: {
          animateScale: true,
          animateRotate: true
        },

        pointLabels: {
          fontSize: 50
        },
        legend: {
          position: "left",
          display: false
        },
        title: {
          display: false,
          text: "Skills"
        },
        scale: {
          pointLabels: {
            fontSize: 12,

            fontColor: "white"
          },
          ticks: {
            display: false,
            beginAtZero: true
          }
        }
      }
    });
  }
};
</script>

<style scoped lang="scss">
body {
  font-size: 11px;
  font-weight: 300;
  fill: #242424;
  text-align: center;
  text-shadow: 0 1px 0 #fff, 1px 0 0 #fff, -1px 0 0 #fff, 0 -1px 0 #fff;
  cursor: default;
  .title {
    // font-size: 4.5em;
    font-size: 7.5vw;
    font-weight: 600;
    letter-spacing: 0.025em;
    color: #585858;
    margin: 0.5em auto 5px;
    img {
      position: relative;
      display: inline-block;
      top: 14px;
      margin-right: 1px;
      opacity: 0.7;
      text.legend {
        font-size: calc(0.8vw + 0.8vh + 0.4vmin);
      }
    }
  }

  .chart-container .radarChart {
    min-width: 300px;
    margin: auto;
    text.legend {
      font-size: calc(0.8vw + 0.8vh + 0.4vmin);
    }
  }
}

.content {
  overflow-y: scroll;
}

::-webkit-scrollbar {
  display: none;
}

.background {
  background-color: transparent;
}

.tile {
  background-color: transparent;
  min-width: 350px;
}

.rounded-circle {
  border-radius: 10%;
}

.legend {
  fill: #333333;
  background-color: blue;
}

.about-bio {
  margin-top: 100px;
  min-width: 300px;
}

.about-content {
  margin-top: 100px;
  overflow-y: scroll;
}

.about-bio-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.tooltip {
  fill: #333333;
}

.md-card {
  width: 320px;
  margin: 20px;
  display: inline-block;
  vertical-align: top;
  background: rgb(253, 253, 253);
}
.radar {
  width: 620px;
  height: 620px;
  margin: 20px;
  display: inline-block;
  vertical-align: top;
  background: rgb(253, 253, 253);
}

.linked {
  background: transparent; /*just for preview*/
}
.xing {
  background: transparent; /*just for preview*/
}

.github {
  background: transparent; /*just for preview*/
}
.mail {
  background: transparent; /*just for preview*/
}

.contact {
  text-align: center;
  background: transparent; /*just for preview*/
}
</style>

